import { Route } from '@/app/router'

const Collection = () => import('./index.vue')

export default new Route('/collections/:id', Collection).as('Dashboard:Collection')
